export class DialogHandler {
  dialogElement;
  onClose;

  constructor(onClose) {
    this.onClose = onClose;
  }

  connect(dialogElement) {
    this.dialogElement = dialogElement;
  }

  showModal() {
    if (!this.dialogElement) return
    this.dialogElement.showModal()
    this.dialogElement.addEventListener("close", this.closeListener)
  }

  close() {
    if (!this.dialogElement) return
    this.dialogElement.removeEventListener("close", this.closeListener)
    this.dialogElement.close()
  }

  closeListener() {
    this.onClose()
  }
}
